import { Component, OnInit } from '@angular/core';
import { NewProductService } from '../services/new-product.service';

@Component({
  selector: 'app-product-form',
  templateUrl: './new-product.component.html',
  styleUrls: ['./new-product.component.scss'],
})
export class NewProductComponent implements OnInit {
  productTypes: any[] = [];
  selectedProductType: string = '';

  constructor(private NewProductService: NewProductService) {}

  ngOnInit(): void {
    this.NewProductService.getProductTypes().subscribe((response) => {
      // Assuming the product types are nested under the "data" key in the response.
      this.productTypes = response.data;
    });
  }

  onSubmit(productData: any): void {
    console.log(productData);
    // event.preventDefault();
    this.NewProductService.addProduct(productData).subscribe(
      (response) => {
        alert('Product added successfully');
        window.location.reload();
      },
      (error) => {
        alert('Please Try Again! Error adding Product'+ error);
        window.location.reload();
      }
    );
  }
}
